import React, { useState, useEffect } from "react";
import Spinner from "@atlaskit/spinner";
import { API } from "../../utility/Api";

//import Messages from "../../components/Dashboard/Messages/Messages";
import styles from "./insights.module.css";
import { cardBgColor, cardColors } from "../../constants/constants";
import Card from "../../components/Dashboard/Card/Card";

import { UseToast } from "../../components/context/ToastContext";

const Insights = (props) => {
  const { setMainMessage } = UseToast();
  const [cardData, setCardData] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [base_url, setBaseUrl] = useState("");
  // const [isError, setError] = useState("");

  const { data } = cardData;

  useEffect(() => {
    const getData = (token) => {
      // setError("");
      setLoading(true);
      API.get("api/stats", {
        headers: {
          Authorization: `JWT ${token}`,
        },
      })
        .then(function (response) {
          setCardData(response.data);
          // setError("");
          setLoading(false);
        })
        .catch(function (error) {
          // setError(error.message);
          setMainMessage({ text: error.message, type: "error" });
          setLoading(false);
        });
    };

    const getUserDetails = async () => {
      //eslint-disable-next-line
      await AP.user.getCurrentUser(function (user) {
        let accountId = user.atlassianAccountId;
        //eslint-disable-next-line
        AP.request(`/rest/api/3/user?accountId=${accountId}`, {
          success: function (responseText) {
            const data = JSON.parse(responseText);
            setBaseUrl(data.self.split("/rest")[0]);
          },
        });
      });
    };
    //eslint-disable-next-line
    AP.context.getToken(function (token) {
      getData(token);
      getUserDetails();
    });
  }, [props.appType]);

  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner size="large" />
      </div>
    );
  }

  // if (isError) {
  //   return (
  //     <div className={styles.error}>
  //       <strong>Something went wrong</strong>
  //       <FlagError setFlag={[1]} message={isError} />
  //     </div>
  //   );
  // }

  return (
    <div className={styles.container}>
      <div className={styles.cardContainer}>
        {data ? (
          data.map((cards, i) => (
            <div className={styles.item} key={cards.title}>
              <Card
                data={cards}
                cardColor={cardColors[i]}
                cardBgColor={cardBgColor[i]}
                base_url={base_url}
              />
            </div>
          ))
        ) : (
          <div className={styles.item}>
            <strong>No data found</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default Insights;
